<template>
  <div class="modal offer-modal">
    <div class="overlay" @click="close"></div>
    <div class="wrapper">
      <img class="close" @click="close" src="./../assets/close.svg" />
      <div class="container">
        <form @submit.prevent>
          <div class="form-wrapper">
            <div class="form-fields">
              <div class="title">
                {{ $t("Order") }} #{{ orderToView.id }}
              </div>
              <div class="form-fields-wrapper">
                <div class="offer-wrapper">
                  <table>
                    <thead>
                      <tr>
                        <td>{{ $t("Skin name") }}</td>
                        <td>{{ $t("Quality") }}</td>
                        <td>{{ $t("Item count") }}</td>
                        <td>{{ $t("Price") }}</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{{ orderToView.title }}</td>
                        <td>{{ orderToView.item_quality }}</td>
                        <td>{{ orderToView.count }}</td>
                        <td>
                          {{ orderToView.sum }}
                          {{ orderToView.currency }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderDetailsModal',
  props: {
    orderToView: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
  methods: {
    close() {
      this.$emit('closeOrderDetailsModal');
    },
  },
};
</script>

<style scoped>
/* Styles are inherited from global style.scss for .offer-modal */
</style>
